var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCC: "http://creativecommons.org/ns#",
    xmlnsDcc: "http://purl.org/dc/elements/1.1/",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2990"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 512,256 C 512,397.3849 397.38489,512 256,512 114.6151,512 -1.47e-6,397.3849 -1.47e-6,256 -1.47e-6,114.61511 114.6151,1.34e-6 256,1.34e-6 397.38489,1.34e-6 512,114.61511 512,256 z",
    id: "path2989",
    style: {
      fill: "#379ad6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3015"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3962",
    points: "389.402,450.579 420.191,117.07 91.809,117.07 122.593,450.579 255.999,486.501 ",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    transform: "matrix(0.66995146,0,0,0.66995146,84.49242,84.15745)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3968",
    points: "364.257,428.863 389.175,144.084 255.997,144.084 255.997,457.852 256.298,457.933 ",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    },
    transform: "matrix(0.66995146,0,0,0.66995146,84.49242,84.15745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 190.7226,143.04082 h 33.95515 v -13.27977 h -19.40246 v -13.29854 h 19.40246 V 101.91049 H 190.7226 v 41.13033 z m 48.4663,-26.57764 c 4.54294,4.54294 6.91189,6.71693 13.48277,13.28849 -3.84016,0 -13.48277,0.0141 -13.48277,0.0127 v 13.27642 h 33.95783 v -13.27974 l -13.56384,-13.29854 h 13.56384 V 101.91049 H 239.1889 c 0,0 0,7.30381 0,14.55269 z m 82.08848,-14.55269 h -33.95984 c 0,0 0,7.30381 0,14.55269 4.54295,4.54294 6.91323,6.71693 13.48412,13.28849 -3.83882,0 -13.48412,0.0141 -13.48412,0.0127 v 13.27642 h 33.95984 v -13.27974 l -13.5645,-13.29854 h 13.5645 v -14.55202 z",
    id: "path4016",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 186.10184,207.69363 4,27.25 69.5,-0.5 -67,28.25 1.75,27 95,0 -2.25,35.5 -30.5,9.25 -31,-8.5 -1.75,-21.25 -27.25,0 3.5,41.75 55.75,16.25 56.75,-15.75 7,-84.25 -64.25,0 66.75,-28.25 2,-27 z",
    id: "path4169",
    style: {
      fill: "#379ad6",
      fillOpacity: 1,
      stroke: "none"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.4f7e65baafb7df069073d64089adf972.svg";
export { ForwardRef as ReactComponent };